import React from 'react';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { InstantSearch, Chat } from 'react-instantsearch';
import 'instantsearch.css/components/chat.css';
import './App.css';

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_API_KEY
);

function App() {
  return (
    <div className="app-container">
      <div className="header">
        <h1 className="title">🤝 Let's Make a Deal</h1>
        <p className="subtitle">
          Real deals for real families · Local &amp; online · Every penny counts
        </p>
        <div className="tags">
          {["🍞 Groceries", "👶 Baby", "🏠 Home", "👕 Clothing", "📱 Tech"].map(
            (tag) => (
              <span key={tag} className="tag">{tag}</span>
            )
          )}
        </div>
      </div>

      <div className="chat-wrapper">
        <InstantSearch searchClient={searchClient}>
          <Chat
            agentId={process.env.REACT_APP_ALGOLIA_AGENT_ID}
          />
        </InstantSearch>
      </div>
    </div>
  );
}

export default App;
